var LicenseType = /* @__PURE__ */ ((LicenseType2) => {
  LicenseType2[LicenseType2["NONE"] = null] = "NONE";
  LicenseType2["CURACAO"] = "0";
  LicenseType2["KR"] = "2";
  LicenseType2["PH"] = "3";
  LicenseType2["TOBIQUE"] = "4";
  LicenseType2["CHINA"] = "5";
  LicenseType2["ANJOUAN"] = "6";
  LicenseType2["CIS"] = "7";
  return LicenseType2;
})(LicenseType || {});
export {
  LicenseType
};
//# sourceMappingURL=types.js.map
